import { render, staticRenderFns } from "./ViewCustomer.vue?vue&type=template&id=539b4866"
import script from "./ViewCustomer.vue?vue&type=script&lang=ts"
export * from "./ViewCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports